module.exports = __webpack_public_path__ + "static/media/xc_test.21ab5787.png";